/* Publish by EComposer at 2026-10-27 16:36:01*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ia73dsm2px"]=  window.__ectimmers["ecom-ia73dsm2px"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ia73dsm2px').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ia73dsm2px', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8j0waf1csnh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8j0waf1csnh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-svki97v9ht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-svki97v9ht', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rdly5tmk8eh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rdly5tmk8eh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-96mvosfpfal"]=  window.__ectimmers["ecom-96mvosfpfal"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-96mvosfpfal"]["lg848rdpp"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-96mvosfpfal').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-96mvosfpfal', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v64v6ekzfk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v64v6ekzfk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1kg9yewqvb4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1kg9yewqvb4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sarskhl2mx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sarskhl2mx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}